import { Helmet } from "react-helmet";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Row, Col, Modal, Typography } from "antd";

import ErrorFallback from "components/ErrorFallback";
import { TableWrapper, ReportContainer } from "./styled";

const { Title } = Typography;

const Report: React.FC = () => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ReportContainer>
        <Helmet>
          <title>Request History</title>
          <meta name="description" content="This page displays the request history." />
        </Helmet>
        <Modal
          okText="Yes"
          title="Select Server"
          maskClosable={false}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
        />
        <Row>
          <Col className="heading" span={24}>
            <Title level={4}>Request History</Title>
          </Col>
        </Row>

        <TableWrapper>
          <Outlet />
        </TableWrapper>
      </ReportContainer>
    </ErrorBoundary>
  );
};

export default Report;
